module.exports = __webpack_public_path__ + "static/media/animal-horse2.083ffb69.aac";